import './yaman-loader.css';

const AppLoader = () => {
  return (
    <div className='app-loader'>
      <div className='yaman-spinner'>
        {/* Using <i> tags to match your splash screen exactly */}
        <i className='yaman-dot'></i>
        <i className='yaman-dot'></i>
        <i className='yaman-dot'></i>
        <i className='yaman-dot'></i>
      </div>
    </div>
  );
};

export default AppLoader;
